export const pumpLogoAnimation = {

    whileHover:{rotate:180 ,transition:{duration:0.1,repeat:0 , restDelta: 5 }} ,
    initial:{
      scale:0
    },
    animate:{
      scale:1,transition: { type: "spring",visualDuration: 0.4, bounce: 0.8,duration: 0.5 }
    }
}

export const buttonAnimation = {
    props:{
        whileHover:{ scale: 1.05 },
        whileTap:{ scale: 0.95 },
        animate:{
          scale:1,transition: { type: "spring",visualDuration: 0.4, bounce: 0.7,duration: 1 , dumping:3 }
        }
    },
    initial:{
      scale:0
    },
    animate:{
      scale:1,transition: { type: "spring",visualDuration: 0.4, bounce: 0.8,duration: 0.5 , dumping:3 }
    }
}



export const blobAnimation = {
props:{
    initial:{opacity:1},
     animate:{opacity:[1,0.5,1]} ,
     transition:{duration:5,repeat:Infinity}
}
    
}

export const SectionAnimation = {
    initial:{opacity:0},
    whileInView:{opacity:1},
     animate:{opacity:[1,0.5,1]} ,
     transition:{duration:3},
     exit:{opacity:0}
}

export const cardsAnimation = {
  variants:{ 
    initial: { opacity: 0 },
    whileInView: {
      opacity: 1,

      transition: {
        staggerChildren: 0.1,
      }
    }
  },
  card:{

    initial: { opacity: 0, y: -100 },
    whileInView: { opacity: 1, y: 0 }

  }
}